import React, { useContext } from "react";
import ShortcutMenuWrapper from "../ShortcutMenuWrapper";
import ReportMenuIcon from "assets/menus/master-maintenance/bim-reports.svg";
import ReportManagementMenuIcon from "assets/menus/master-maintenance/business-intelligence-management.svg";
import { useSelector } from "react-redux";
import { RootState } from "@app/store/store";
import { canAccess } from "@app/utils/permissionUtils";
import { VariantContext } from "@app/variant";

export const ReportingConfigureMenu: React.FC = () => {
    const state = useSelector((state: RootState) => state); // Get the entire state
    const { id } = useContext(VariantContext); // "control" | "user"
    if (id === "control") {
        return (
            <ShortcutMenuWrapper
                title="shortcutMenus.reportConfiguration.title"
                icon={ReportManagementMenuIcon}
                menus={[
                    {
                        title: 'shortcutMenus.reportConfiguration.reportConfigure',
                        icon: ReportMenuIcon,
                        url: '/reporting/reporting/list',
                        categoryIcon: ReportManagementMenuIcon,
                        show: canAccess(state, 'reportConfigure.management')
                    }
                ]}
            />
        );
    }
    if (id === "user") {
        return (
            <ShortcutMenuWrapper
                title="shortcutMenus.reportConfiguration.title"
                icon={ReportManagementMenuIcon}
                menus={[
                    {
                        title: 'shortcutMenus.reportConfiguration.reportConfigure',
                        icon: ReportMenuIcon,
                        url: '/reporting/reporting/list',
                        categoryIcon: ReportManagementMenuIcon,
                        show: canAccess(state, 'reportConfigure.management')
                    }
                ]}
            />
        );
    }
    return null;
}